import * as yup from 'yup';

const validationSchema = yup.object({
  type: yup.string().required('Required'),
});

export default validationSchema;
